import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminUsersPage } from './admin-users';

@NgModule({
  declarations: [
    AdminUsersPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminUsersPage),
  ],
})
export class AdminUsersPageModule {}



// WEBPACK FOOTER //
// ./src/pages/admin-users/admin-users.module.ts